export default __webpack_public_path__ + "static/media/calendar.6f992abf.svg";